import { green, orange, red } from '@ant-design/colors';
import { Card, Progress } from 'antd';
import { FC, useCallback, useMemo } from 'react';

import { useSelectEnemy } from '../store/game.hooks';
import { useEnemyStore } from '../store/game.store';
import { calculateHealthPercentage } from '../utils';

interface EnemyCardProps extends React.PropsWithChildren {
   id: string;
   className?: string;
   imageClassName?: string;
}
export const EnemyCard: FC<EnemyCardProps> = ({ id, className, imageClassName }) => {
   const { actions: enemyActions } = useEnemyStore();
   const enemy = useSelectEnemy({ enemyId: id });

   const healthPercentage = useMemo(() => calculateHealthPercentage({ currentHealth: enemy.currentHealth, maxHealth: enemy.maxHealth }), [enemy]);

   const progressColour = useMemo(() => {
      switch (true) {
         case healthPercentage > 90:
            return green[5];
         case healthPercentage > 75:
            return green[3];
         case healthPercentage > 50:
            return orange[5];
         case healthPercentage > 25:
            return red[3];
         default:
            return red[5];
      }
   }, [healthPercentage]);


   const cardClassName = `${enemy.isActiveTarget ? 'enemyActive' : 'enemyNotActive'}`;
   const enemyDeadClass = `${enemy.isDead ? 'enemyIsDead' : 'enemyIsNotDead'}`;
   const enemyStunnedClass = `${enemy.isStunned ? 'enemyIsStunned' : 'enemyIsNotStunned'}`;

   const allEnemyConditionalClasses = cardClassName+ ' '+enemyDeadClass+' '+enemyStunnedClass+ ' width15percent paddy ';

   const handleTargetEnemy = useCallback(() => {
      if (!enemy.isDead) {
         enemyActions.setActiveTarget(id);
      }
     
   }, [id, enemyActions, enemy]);

   return (

      

      <div className={allEnemyConditionalClasses} >
            <Card
               onClick={handleTargetEnemy}
               hoverable
               cover={
                  <img
                     src={enemy.imageFilePath}
                     alt={enemy.name}
                     className={imageClassName}
                  />
               }
               className={className}
            >
               <p className='squash'>{enemy.name}</p>
               <Progress
                  percent={healthPercentage}
                  strokeColor={progressColour}
                  showInfo={false}
               /> 
            </Card>
   
      </div>


   );
};
